import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetLeadDataTrackingService extends Service {
  constructor({trackingLeadMapper, getAdvertisementsTrackingService}) {
    super({trackingLeadMapper})
    this._trackingLeadMapper = trackingLeadMapper
    this._getAdvertisementsTrackingService = getAdvertisementsTrackingService
  }

  /**
   * @return {Promise<LeadTrackingData, Error>}
   */
  @inlineError
  async execute({
    ad,
    adType,
    dealerId,
    context,
    filters,
    filtersString,
    financingInstalmentPrice,
    product,
    subscriptionPriceOption,
    modelDetailLeadType,
    transactionInfo,
    pageType,
    pageNameOrigin
  }) {
    const advertisementsVO = await this._getAdvertisementsTrackingService.execute({
      ads: [ad],
      context: context || 'other',
      listType: product?.list_type
    })
    const data = this._trackingLeadMapper
      .setParams({
        products: product ? [product] : advertisementsVO.getProducts()
      })
      .map({
        ad,
        adType,
        dealerId,
        filters,
        filtersString,
        financingInstalmentPrice,
        listType: product?.list_type,
        subscriptionPriceOption,
        modelDetailLeadType,
        transactionInfo,
        pageType,
        pageNameOrigin
      })

    return data
  }
}
